import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { FieldConfig } from '../../../_models/field.interface';
@Component({
  selector: 'app-slider',
  template: `
    <div
      [formGroup]="group"
      [style.visibility]="!field.visible ? 'hidden' : 'visible'"
    >
      <mat-slider
        min="1"
        [max]="field.maxSize"
        step="1"
        [(ngModel)]="field.value"
        [id]="field.name"
        [disabled]="field.disabled"
        [ngStyle]="field.style()"
        (change)="field.change($event)"
      ></mat-slider>
    </div>
  `,
  styles: [],
})
export class SliderComponent implements OnInit {
  field: FieldConfig;
  group: UntypedFormGroup;

  constructor() {}
  ngOnInit() {}
}
